// Detect whether the current page is being served from the Reader subdomain
// (reader.lingvishspace.com in production, reader.localhost in dev). Used to
// switch the app between "Platform" mode (full route table) and "Reader-only"
// mode (just the book-reading flow), and to swap in the Reader PWA manifest.
//
// In dev, Chrome automatically resolves *.localhost to 127.0.0.1, so
// http://reader.localhost:3000 hits the same webpack dev server as
// http://localhost:3000 — no /etc/hosts changes needed.
export const isReaderHost = () => {
  if (typeof window === 'undefined') return false;
  const h = window.location.hostname;
  return h === 'reader.lingvishspace.com' || h.startsWith('reader.');
};

// Absolute URL of the Reader app, used by the main platform when sending
// users over to Reader (e.g. dashboard "Open Reader" buttons). In prod this
// is the subdomain (its own PWA, its own manifest). In dev we stay on the
// same origin — browsers won't share cookies with reader.localhost
// (public-suffix rule), and the Reader routes exist under the main platform
// origin anyway. Devs can still test subdomain PWA behavior by visiting
// reader.localhost:3000 directly.
export const getReaderOrigin = () => {
  if (typeof window === 'undefined') return '';
  const { protocol, hostname, port } = window.location;
  if (hostname === 'lingvishspace.com' || hostname === 'www.lingvishspace.com') {
    return 'https://reader.lingvishspace.com';
  }
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return `${protocol}//${hostname}${port ? `:${port}` : ''}`;
  }
  // Fallback: same origin (covers preview deploys / unknown hosts).
  return `${protocol}//${hostname}${port ? `:${port}` : ''}`;
};

// Absolute URL of the main platform. Inverse of getReaderOrigin — used from
// the Reader subdomain when sending users back to the platform (e.g. the
// Reader header's back button → student/teacher profile).
export const getPlatformOrigin = () => {
  if (typeof window === 'undefined') return '';
  const { protocol, hostname, port } = window.location;
  if (hostname === 'reader.lingvishspace.com') {
    return 'https://lingvishspace.com';
  }
  if (hostname.startsWith('reader.')) {
    const base = hostname.slice('reader.'.length);
    return `${protocol}//${base}${port ? `:${port}` : ''}`;
  }
  return `${protocol}//${hostname}${port ? `:${port}` : ''}`;
};
